import React, { RootState, useAppSelector } from '@/state/store';
import t from '@/utils/translate';

type Versions = undefined | string[];

function formatVersions(v: string[]): string {
  
  if (v.length === 1) return `${t('model.rvt.version', { count: 1 })} ${v[0]}`;

  const src: (string | number)[] = v.map((ver) => {
    const num = Number.parseInt(ver);
    return (Number.isNaN(num)) ? ver : num;
  }).sort((a, b) => {
    if (typeof a === 'number' && typeof b === 'number') return a - b;
    const a1 = (typeof a === 'number') ? a : parseInt(a);
    const b1 = (typeof b === 'number') ? b : parseInt(b);
    return a1 - b1;
  });

  const result: string[] = [];

  let start = src[0];
  let startIdx = 0;

  for (let i = 1; i < src.length; i++) {
    if (
      (typeof src[i - 1] !== typeof src[i]) ||
      (typeof src[i] === 'string') ||
      (src[i - 1] !== (src[i] as number) - 1)
    ) {
      result.push((startIdx === i - 1) ? `${start}` : `${start}-${src[i - 1]}`);
      start = src[i];
      startIdx = i;
    }
    if (i === src.length - 1) {
      result.push((startIdx === i) ? `${src[i]}` : `${start}-${src[i]}`);
    }
  }

  return `${t('model.rvt.version', { count: v.length })} ${result.join(', ')}`;
}

export default () => {
  const features = useAppSelector((state: RootState) => state.common.features);
  const versions = features['RVT_CONVERTER.SUPPORTED_REVIT_VERSIONS'] as Versions;

  if (versions && !!versions.length) {
    return (<>{t('model.rvt.message.supported', { versions: formatVersions(versions) }, true)}</>);
  }

  return (<></>);
};